import React from "react";
import PropTypes from "prop-types";

export function VerifyCodeInfoMessage({ email }) {
  if (!email) return null;

  return (
    <div data-test="verify-code-info-message" style={{ textAlign: "center" }}>
      <div
        style={{ fontSize: "24px", fontWeight: "700", lineHeight: "normal" }}
      >
        Verification code sent!
      </div>
      <div>
        Enter the six-digit verification code sent to <b>{email}</b>
      </div>
    </div>
  );
}

VerifyCodeInfoMessage.propTypes = {
  email: PropTypes.string,
};

VerifyCodeInfoMessage.defaultProps = {
  email: "",
};

export default VerifyCodeInfoMessage;
